import React from 'react';

const Footer = () => {
  return (
    <div className="footer">Copyright &copy; Products By Design</div>
  )
}

export default Footer;